"use strict";
var ApiPackageRequest = (function () {
    function ApiPackageRequest() {
    }
    return ApiPackageRequest;
}());
exports.ApiPackageRequest = ApiPackageRequest;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-package-request.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-package-request.model.js